var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.35C11.72 21.35 11.45 21.25 11.24 21.05L4.1 14.36C2.75 13.09 2 11.36 2 9.5 2 5.91 4.91 3 8.5 3c1.34 0 2.62.41 3.5 1.35C12.88 3.41 14.16 3 15.5 3 19.09 3 22 5.91 22 9.5c0 1.86-.75 3.59-2.1 4.86l-7.14 6.69c-.21.2-.48.3-.76.3Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.35c-.28 0-.55-.1-.76-.3L4.1 14.36C2.75 13.09 2 11.36 2 9.5 2 5.91 4.91 3 8.5 3c1.34 0 2.62.41 3.5 1.35V21.35Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12h10c-.19 1.06-.86 2.5-2.1 3.36l-2.4-.36-1.5 2-4-5Z",
    fill: "#34A853",
    opacity: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.75h3l1.25-2.5 2 4 1.25-1.5h3.5",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleHealth);
export default __webpack_public_path__ + "static/media/google-health.a885e342e09c5f0779e35091bd7bf2a4.svg";
export { ForwardRef as ReactComponent };